<div class="tooltip-container" >
  @for (tooltip of service.active; track tooltip; let i = $index) {
    <div>
      @if (tooltip === service.activeTooltip) {
        <app-tooltip
          [tooltip]="tooltip"
          [index]="i"
        ></app-tooltip>
      }
    </div>
  }
  @if (showSoloTip()) {
    <app-tooltip
      [tooltip]="service.soloTip"
      [index]="i"
    ></app-tooltip>
  }
</div>
@if (service.activeTooltip) {
  <div (click)="service.close()"  class="overlay fadein-quick">
  </div>
}
